module.exports = function () {
  return new Worker(__webpack_public_path__ + "360bc8be5c698ce6da59.worker.js");
};